import type { ExcalidrawFontFaceDescriptor } from "../Fonts";

// Times New Roman - system font, no external loading needed
export const TimesNewRomanFontFaces: ExcalidrawFontFaceDescriptor[] = [];